export const chunkArray = <T>(array: T[], size: number): T[][] => {
  return array.reduce((acc: T[][], _, index) => {
    if (index % size === 0) {
      acc.push(array.slice(index, index + size));
    }
    return acc;
  }, []);
};
